import L from "./index203.mjs";
import q from "./index204.mjs";
import I from "./index205.mjs";
import z from "./index206.mjs";
import H from "./index207.mjs";
import $ from "./index208.mjs";
import { isProtectedWeekYearToken as Q, throwProtectedError as U, isProtectedDayOfYearToken as Z } from "./index209.mjs";
import D from "./index210.mjs";
import j from "./index211.mjs";
import K from "./index212.mjs";
var B = 10, G = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, J = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, V = /^'([^]*?)'?$/, X = /''/g, _ = /\S/, ee = /[a-zA-Z]/;
function ve(t, y, u, Y) {
  K(3, arguments);
  var a = String(t), p = String(y), l = Y || {}, i = l.locale || L;
  if (!i.match)
    throw new RangeError("locale must contain match property");
  var P = i.options && i.options.firstWeekContainsDate, M = P == null ? 1 : D(P), k = l.firstWeekContainsDate == null ? M : D(l.firstWeekContainsDate);
  if (!(k >= 1 && k <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var W = i.options && i.options.weekStartsOn, A = W == null ? 0 : D(W), O = l.weekStartsOn == null ? A : D(l.weekStartsOn);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (p === "")
    return a === "" ? I(u) : /* @__PURE__ */ new Date(NaN);
  var d = {
    firstWeekContainsDate: k,
    weekStartsOn: O,
    locale: i
  }, h = [{
    priority: B,
    subPriority: -1,
    set: te,
    index: 0
  }], o, x = p.match(J).map(function(r) {
    var n = r[0];
    if (n === "p" || n === "P") {
      var g = H[n];
      return g(r, i.formatLong, d);
    }
    return r;
  }).join("").match(G), m = [];
  for (o = 0; o < x.length; o++) {
    var e = x[o];
    !l.useAdditionalWeekYearTokens && Q(e) && U(e, p, t), !l.useAdditionalDayOfYearTokens && Z(e) && U(e, p, t);
    var f = e[0], s = j[f];
    if (s) {
      var C = s.incompatibleTokens;
      if (Array.isArray(C)) {
        for (var S = void 0, w = 0; w < m.length; w++) {
          var b = m[w].token;
          if (C.indexOf(b) !== -1 || b === f) {
            S = m[w];
            break;
          }
        }
        if (S)
          throw new RangeError("The format string mustn't contain `".concat(S.fullToken, "` and `").concat(e, "` at the same time"));
      } else if (s.incompatibleTokens === "*" && m.length)
        throw new RangeError("The format string mustn't contain `".concat(e, "` and any other token at the same time"));
      m.push({
        token: f,
        fullToken: e
      });
      var E = s.parse(a, e, i.match, d);
      if (!E)
        return /* @__PURE__ */ new Date(NaN);
      h.push({
        priority: s.priority,
        subPriority: s.subPriority || 0,
        set: s.set,
        validate: s.validate,
        value: E.value,
        index: h.length
      }), a = E.rest;
    } else {
      if (f.match(ee))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + f + "`");
      if (e === "''" ? e = "'" : f === "'" && (e = re(e)), a.indexOf(e) === 0)
        a = a.slice(e.length);
      else
        return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (a.length > 0 && _.test(a))
    return /* @__PURE__ */ new Date(NaN);
  var R = h.map(function(r) {
    return r.priority;
  }).sort(function(r, n) {
    return n - r;
  }).filter(function(r, n, g) {
    return g.indexOf(r) === n;
  }).map(function(r) {
    return h.filter(function(n) {
      return n.priority === r;
    }).sort(function(n, g) {
      return g.subPriority - n.subPriority;
    });
  }).map(function(r) {
    return r[0];
  }), N = I(u);
  if (isNaN(N))
    return /* @__PURE__ */ new Date(NaN);
  var c = q(N, $(N)), F = {};
  for (o = 0; o < R.length; o++) {
    var v = R[o];
    if (v.validate && !v.validate(c, v.value, d))
      return /* @__PURE__ */ new Date(NaN);
    var T = v.set(c, F, v.value, d);
    T[0] ? (c = T[0], z(F, T[1])) : c = T;
  }
  return c;
}
function te(t, y) {
  if (y.timestampIsSet)
    return t;
  var u = /* @__PURE__ */ new Date(0);
  return u.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), u.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()), u;
}
function re(t) {
  return t.match(V)[1].replace(X, "'");
}
export {
  ve as default
};
//# sourceMappingURL=index167.mjs.map
